import "./TableWidget.scss";
import React from "react";
import cn from "classnames";

interface TableWidgetProps {
  twHeaderTopLeft: React.ReactNode;
  twHeaderTopRight: React.ReactNode;
  headerBottom?: React.ReactNode;
  tableComponent: React.ReactNode;
  twFooter?: React.ReactNode;
  widgetClassName?: string | Record<string, boolean>;
  headerClassName?: string | Record<string, boolean>;
  bodyClassName?: string | Record<string, boolean>;
}

const TableWidget = ({
  twHeaderTopLeft,
  twHeaderTopRight,
  headerBottom,
  tableComponent,
  twFooter,
  widgetClassName,
  headerClassName,
  bodyClassName,
}: TableWidgetProps): JSX.Element => {
  return (
    <div className={cn("tableWidget", widgetClassName)}>
      <div className={cn("twHeader", headerClassName)}>
        <div className="twHeaderTop">
          <div className="twHeaderTopLeft">{twHeaderTopLeft}</div>
          <div className="twHeaderTopRight">{twHeaderTopRight}</div>
        </div>
        {headerBottom && <div className="twHeaderBot">{headerBottom}</div>}
      </div>
      <div className={cn("twBody", bodyClassName)}>{tableComponent}</div>
      {twFooter && <div className="twFooter">{twFooter}</div>}
    </div>
  );
};

export default TableWidget;
